"use strict";
/** state: Final **/
/** family: NavBar **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var CLASS_NAME = 'i-nav';
var NavStyle;
(function (NavStyle) {
    NavStyle["Pills"] = "pills";
    NavStyle["Tabs"] = "tabs";
})(NavStyle = exports.NavStyle || (exports.NavStyle = {}));
var NavRole;
(function (NavRole) {
    NavRole["TabList"] = "tablist";
})(NavRole = exports.NavRole || (exports.NavRole = {}));
/**
 * Inject `isMobile` prop into NavItem children.
 */
var injectPropsOnChildren = function (children, isMobile) {
    return React.Children.map(children, function (child) {
        return child ? React.cloneElement(child, { isMobile: isMobile }) : child;
    });
};
/**
 * Nav group of items.
 * @param props {@link NavProps}
 */
var Nav = (function (_a) {
    var className = _a.className, children = _a.children, isMobile = _a.isMobile, navBar = _a.navBar, navStyle = _a.navStyle, rightAlign = _a.rightAlign, restProps = __rest(_a, ["className", "children", "isMobile", "navBar", "navStyle", "rightAlign"]);
    var _b;
    return (React.createElement("ul", __assign({ className: classNames(CLASS_NAME, className, (_b = {
                nav: !navBar,
                'nav-pills': navStyle && navStyle === NavStyle.Pills,
                'nav-tabs': navStyle && navStyle === NavStyle.Tabs,
                'navbar-nav': navBar
            },
            _b[CLASS_NAME + "--right"] = rightAlign,
            _b)) }, restProps), injectPropsOnChildren(children, isMobile)));
});
exports.Nav = Nav;
Nav.Style = NavStyle;
//# sourceMappingURL=Nav.js.map